<template>
    <div class="other-login">
        <div class="other-login-title">
            <div class="title-line"></div>
            <span class="title-text">其他登录方式</span>
            <div class="title-line"></div>
        </div>
        <div class="login-options">
            <!-- 在账号密码登录页面显示微信登录和手机验证码登录 -->
            <template v-if="isPasswordLoginPage">
                <a href="javascript:void(0)" class="login-option" @click.prevent="onWeChatClick">
                    <div class="option-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M16.0105 8.54754C16.2683 8.54754 16.5261 8.57135 16.7826 8.59385C16.0927 5.39212 12.6317 3 8.68915 3C4.28046 3.01547 0.667969 5.99515 0.667969 9.77873C0.667969 11.96 1.87216 13.7591 3.87246 15.1519L3.06506 17.5413L5.87278 16.1499C6.87867 16.3466 7.68614 16.5434 8.67923 16.5434C8.93705 16.5434 9.1822 16.5322 9.42722 16.5096C9.26799 15.9663 9.18551 15.4033 9.18218 14.8372C9.19355 11.3684 12.1996 8.54894 16.0119 8.54894L16.0105 8.54754H16.0105ZM11.6953 6.39148C12.3045 6.39148 12.7011 6.78499 12.7011 7.38933C12.7011 7.97967 12.3045 8.38727 11.6953 8.38727C11.0989 8.38727 10.4911 7.99235 10.4911 7.3893C10.4911 6.78499 11.0989 6.39148 11.6953 6.39148ZM6.08102 8.38727C5.48609 8.38727 4.87695 7.99235 4.87695 7.3893C4.87695 6.78499 5.48609 6.39148 6.08102 6.39148C6.67751 6.39148 7.08691 6.78499 7.08691 7.38933C7.08691 7.97967 6.69026 8.38727 6.08102 8.38727ZM23.3347 14.7542C23.3347 11.575 20.1302 8.97621 16.5147 8.97621C12.7025 8.97621 9.69635 11.575 9.69635 14.7542C9.69635 17.9447 12.7025 20.5336 16.5147 20.5336C17.311 20.5336 18.1184 20.3368 18.9245 20.1386L21.1232 21.3333L20.5155 19.3487C22.1305 18.1316 23.3347 16.5405 23.3347 14.7542ZM14.3048 13.7562C13.9081 13.7562 13.4973 13.3627 13.4973 12.9551C13.4973 12.5616 13.9081 12.1541 14.3048 12.1541C14.9139 12.1541 15.3107 12.549 15.3107 12.9551C15.3107 13.3627 14.9139 13.7562 14.3048 13.7562ZM18.7149 13.7562C18.3168 13.7562 17.9187 13.3627 17.9187 12.9551C17.9187 12.5616 18.3154 12.1541 18.7149 12.1541C19.3226 12.1541 19.7207 12.549 19.7207 12.9551C19.7207 13.3627 19.3226 13.7562 18.7149 13.7562Z"
                                fill="#09BB07" />
                        </svg>
                    </div>
                    <span class="option-text">微信登录</span>
                </a>
                <router-link to="/store/entry/loginEmail" class="login-option">
                    <div class="option-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                                fill="currentColor" />
                        </svg>
                    </div>
                    <span class="option-text">手机验证码登录</span>
                </router-link>
            </template>
            <!-- 在手机验证码登录页面显示微信登录和账号密码登录 -->
            <template v-else>
                <a href="javascript:void(0)" class="login-option" @click.prevent="onWeChatClick">
                    <div class="option-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M16.0105 8.54754C16.2683 8.54754 16.5261 8.57135 16.7826 8.59385C16.0927 5.39212 12.6317 3 8.68915 3C4.28046 3.01547 0.667969 5.99515 0.667969 9.77873C0.667969 11.96 1.87216 13.7591 3.87246 15.1519L3.06506 17.5413L5.87278 16.1499C6.87867 16.3466 7.68614 16.5434 8.67923 16.5434C8.93705 16.5434 9.1822 16.5322 9.42722 16.5096C9.26799 15.9663 9.18551 15.4033 9.18218 14.8372C9.19355 11.3684 12.1996 8.54894 16.0119 8.54894L16.0105 8.54754H16.0105ZM11.6953 6.39148C12.3045 6.39148 12.7011 6.78499 12.7011 7.38933C12.7011 7.97967 12.3045 8.38727 11.6953 8.38727C11.0989 8.38727 10.4911 7.99235 10.4911 7.3893C10.4911 6.78499 11.0989 6.39148 11.6953 6.39148ZM6.08102 8.38727C5.48609 8.38727 4.87695 7.99235 4.87695 7.3893C4.87695 6.78499 5.48609 6.39148 6.08102 6.39148C6.67751 6.39148 7.08691 6.78499 7.08691 7.38933C7.08691 7.97967 6.69026 8.38727 6.08102 8.38727ZM23.3347 14.7542C23.3347 11.575 20.1302 8.97621 16.5147 8.97621C12.7025 8.97621 9.69635 11.575 9.69635 14.7542C9.69635 17.9447 12.7025 20.5336 16.5147 20.5336C17.311 20.5336 18.1184 20.3368 18.9245 20.1386L21.1232 21.3333L20.5155 19.3487C22.1305 18.1316 23.3347 16.5405 23.3347 14.7542ZM14.3048 13.7562C13.9081 13.7562 13.4973 13.3627 13.4973 12.9551C13.4973 12.5616 13.9081 12.1541 14.3048 12.1541C14.9139 12.1541 15.3107 12.549 15.3107 12.9551C15.3107 13.3627 14.9139 13.7562 14.3048 13.7562ZM18.7149 13.7562C18.3168 13.7562 17.9187 13.3627 17.9187 12.9551C17.9187 12.5616 18.3154 12.1541 18.7149 12.1541C19.3226 12.1541 19.7207 12.549 19.7207 12.9551C19.7207 13.3627 19.3226 13.7562 18.7149 13.7562Z"
                                fill="#09BB07" />
                        </svg>
                    </div>
                    <span class="option-text">微信登录</span>
                </a>
                <router-link to="/store/entry/loginPwd" class="login-option">
                    <div class="option-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                            <path
                                d="M18.7016 8.8H17.6016V6.6C17.6016 5.72 17.3816 4.73 17.0516 3.96V3.85L16.7216 3.19L16.6116 3.08C16.5016 2.86 16.2816 2.64 16.0616 2.42L15.9516 2.31C15.8416 2.09 15.6216 1.98 15.4016 1.76L15.2916 1.65C15.0716 1.43 14.8516 1.32 14.6316 1.1C14.6316 1.1 14.5216 1.1 14.5216 0.99L13.8616 0.66C13.7516 0.66 13.7516 0.55 13.6416 0.55C13.4216 0.44 13.0916 0.33 12.8716 0.22H12.7616C12.5416 0.11 12.3216 0.11 12.1016 0.11H11.8816C11.5516 0 11.3316 0 11.0016 0C10.6716 0 10.4516 0 10.1216 0.11H9.90156C9.68156 0.11 9.46156 0.22 9.24156 0.22H9.13156C8.80156 0.33 8.58156 0.44 8.25156 0.55C8.14156 0.55 8.14156 0.66 8.03156 0.66C7.92156 0.77 7.70156 0.88 7.48156 0.99C7.48156 0.99 7.37156 0.99 7.37156 1.1C7.15156 1.21 6.93156 1.43 6.71156 1.65C6.60156 1.65 6.60156 1.65 6.60156 1.76C6.38156 1.87 6.16156 2.09 6.05156 2.2L5.94156 2.31C5.72156 2.53 5.61156 2.75 5.50156 3.08L5.39156 3.19C5.28156 3.41 5.06156 3.63 5.06156 3.85V3.96C4.62156 4.73 4.40156 5.72 4.40156 6.6V8.8H3.30156C2.09156 8.8 1.10156 9.79 1.10156 11V19.8C1.10156 21.01 2.09156 22 3.30156 22H18.7016C19.9116 22 20.9016 21.01 20.9016 19.8V11C20.9016 9.79 19.9116 8.8 18.7016 8.8ZM6.60156 6.6C6.60156 5.72 6.82156 4.95 7.37156 4.18C7.37156 4.07 7.48156 4.07 7.48156 3.96L7.81156 3.63L8.03156 3.41L8.47156 2.97L8.58156 2.86L9.24156 2.53C9.35156 2.53 9.35156 2.53 9.46156 2.42C9.68156 2.31 9.90156 2.31 10.0116 2.2H11.0016C11.2216 2.2 11.5516 2.2 11.7716 2.31H11.9916C12.2116 2.31 12.4316 2.42 12.5416 2.53C12.6516 2.53 12.6516 2.53 12.7616 2.64L13.4216 2.97L13.5316 3.08C13.7516 3.19 13.8616 3.3 13.9716 3.52L14.1916 3.74C14.3016 3.85 14.4116 3.96 14.5216 4.18C14.5216 4.29 14.6316 4.29 14.6316 4.4C15.0716 4.95 15.4016 5.72 15.4016 6.6V8.8H6.60156V6.6Z"
                                fill="url(#paint0_linear_5230_9815)" />
                            <defs>
                                <linearGradient id="paint0_linear_5230_9815" x1="1.10156" y1="11" x2="20.9016" y2="11"
                                    gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#62AFFF" />
                                    <stop offset="1" stop-color="#9C41FF" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <span class="option-text">账号密码登录</span>
                </router-link>
            </template>
        </div>
        <div class="forgot-password">
            <router-link to="/store/entry/forgottenPwd" class="forgot-link">
                <span>忘记密码?</span>
                <img src="../loginPwd/assets/img/FigmaDDSSlicePNG6c0fa38108e4c2ad2866cfc5dfcc6b7f.png" alt="忘记密码" />
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OtherLoginMethods',
    computed: {
        isPasswordLoginPage() {
            return this.$route.path === '/store/entry/loginPwd'
        }
    },
    methods: {
        onWeChatClick() {
            this.$router.push('/store/entry/loginQRCode')
        }
    }
}
</script>

<style scoped>
/* 其他登录方式样式 */
.other-login {
    background: transparent;
    position: relative;
    z-index: 10;
    margin-top: 20px;
    padding-bottom: 20px;
    overflow: visible;
    max-width: 100%;
    box-sizing: border-box;
}

.other-login-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.title-line {
    flex: 1;
    height: 1px;
    background: #999;
    margin: 0 15px;
}

.title-text {
    margin: 0 15px;
    font-size: 16px;
    color: #666;
}

.login-options {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    gap: 20px;
    overflow: visible;
    max-width: 100%;
    box-sizing: border-box;
}

.login-option {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    color: #333;
    flex: 1;
}

.option-icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
}

.option-icon img,
.option-icon svg {
    width: 28px;
    height: 28px;
}

.option-text {
    font-size: 15px;
    font-weight: 500;
}

.forgot-password {
    text-align: center;
    margin-top: 10px;
    overflow: visible;
    max-width: 100%;
    box-sizing: border-box;
}

.forgot-link {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    text-decoration: none;
    color: #666;
    font-size: 15px;
}

.forgot-link img {
    width: 18px;
    height: 18px;
}
</style>